import { render } from "./TerminalCreate.vue?vue&type=template&id=7a5ecbda&scoped=true&ts=true"
import script from "./TerminalCreate.vue?vue&type=script&lang=ts"
export * from "./TerminalCreate.vue?vue&type=script&lang=ts"

import "./TerminalCreate.vue?vue&type=style&index=0&id=7a5ecbda&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5ecbda"]])

export default __exports__